import styled from 'styled-components'

const ProductsContainer = styled.div``

export { ProductsContainer }
